/* eslint-disable max-statements */
/* eslint-disable max-len */
import React from 'react';
import {Modal, Button, Grid, Popup, Icon} from 'semantic-ui-react';
import HistoryColorModal from '../historyColorModal';
import ModelInfo from './modelInfo/modelInfo';
import MaintainanceTable from './table/table';
import './vehiclesPriceColor.scss';
import {useVehiclesPriceColor} from './useVehiclesPriceColor';


const VehiclesPriceColor = ({
  modalIsOpen,
  selectedVehicle,
  handleCloseModal,
}) => {
  const {
    'actions': {
      onCloseModal,
      updateMyData,
      setModalHistoryPriceWasOpen,
      selectedProduction,
    },
    'data': {
      modelInfoProps,
      loading,
      modalHistoryPriceWasOpen,
      data,
      columns,
    },
  } = useVehiclesPriceColor({
    modalIsOpen,
    'selectedVehicle': selectedVehicle?.values || selectedVehicle,
    handleCloseModal,
  });
  return (
    <Modal size={'fullscreen'} className='stock-download-modal' open={modalIsOpen}>
      <Modal.Header>
        <Grid textAlign='left'>
          <Grid.Column width={5}>
            <Grid.Row>
              Administración de Costos C&F:
              <Popup
                trigger={
                  <Icon link name='info circle' color='red' size='large' />
                }
                on='click'
                position='bottom left'
                inverted
              >
                <div>
                  Pantalla de administración de costos de colores que serán utilizados para el vehículo
                </div>
              </Popup>
            </Grid.Row>
            <Grid.Row>
              {selectedVehicle?.values?.masterCode}
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <div className='title-bar'>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <ModelInfo {...modelInfoProps} />
              </Grid>
            </div>
          </div>
          <MaintainanceTable
            columns={columns}
            data={data || []}
            loading={loading}
            updateMyData={updateMyData}
          />
          {modalHistoryPriceWasOpen &&
            <HistoryColorModal
              modalWasOpen={modalHistoryPriceWasOpen}
              selectedVehicle={selectedVehicle?.values}
              onCloseModal={() => setModalHistoryPriceWasOpen(false)}
              selectedProduction={selectedProduction}
            />
          }
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button basic onClick={onCloseModal}>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default VehiclesPriceColor;
